import Button from '../../Button'
import { Container } from '../Container'

import { BUTTON_ICON_SIZES, BUTTON_SIZES } from './Buttons.constants'

import * as styles from './Buttons.module.css'

import EditIcon from '../../../icons/edit.svg'
import PlusIcon from '../../../icons/plus.svg'

export function FlatGrey() {
  return (
    <>
      <Container label='Button, flat, grey, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Flat
            isGrey
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, flat, grey, disabled, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Flat
            disabled
            isGrey
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, flat, grey, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Flat
            isGrey
            isLoading
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, flat, grey, with pre icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Flat
            isGrey
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, flat, grey, with pre icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Flat
            isGrey
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, flat, grey, with post icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Flat
            isGrey
            afterIconProps={{ Icon: EditIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, flat, grey, with post icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Flat
            isGrey
            isLoading
            afterIconProps={{ Icon: EditIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, flat, grey, icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Flat
            isGrey
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, flat, grey, disabled, icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Flat
            disabled
            isGrey
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, flat, grey, icon, with loader, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Flat
            isGrey
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, flat, grey, circle icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Flat
            isCircle
            isGrey
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, flat, grey, disabled, circle icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Flat
            disabled
            isCircle
            isGrey
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, flat, grey, circle icon, with loader, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Flat
            isCircle
            isGrey
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
